import { CITIES } from "../data";

export const CitiesStrip = () => (
  <div className="cities-strip" data-testid="cities-strip" aria-label="Cidades atendidas">
    <div className="cities-track">
      {[...CITIES, ...CITIES].map((c, i) => (
        <a href={`/praias/desentupidora-${c.slug}.html`} key={`${c.slug}-${i}`} className="strip-item">
          🌊 {c.name}
        </a>
      ))}
    </div>
  </div>
);

export const CitiesSection = () => (
  <section className="section alt" id="praias" data-testid="cities-section">
    <div className="container two-col">
      <div>
        <span className="section-tag">SEO Local hiperavançado</span>
        <h2>Cidades e Praias Atendidas no Litoral Paulista</h2>
        <p>
          Atendimento em todas as praias do litoral paulista, com conteúdo e equipes
          regionalizadas para praias, condomínios, casas de temporada, restaurantes
          litorâneos, caixas de gordura, maresia, umidade e redes antigas.
        </p>
        <div className="cities-cols">
          {CITIES.map((c) => (
            <a
              href={`/praias/desentupidora-${c.slug}.html`}
              key={c.slug}
              data-testid={`city-link-${c.slug}`}
            >
              📍 Desentupidora {c.name}
            </a>
          ))}
        </div>
        <a href="/cidades/desentupidora-litoral-paulista.html" className="card-link mother-link" data-testid="litoral-mae-link">
          Ver página completa do Litoral Paulista
        </a>
      </div>
      <div>
        <div className="img-card" style={{ marginTop: 0 }}>
          <img
            src="/img/equipe-desentope-maresias-litoral.webp"
            alt="Equipe da Desentope Maresias com van equipada atendendo em praia do litoral de São Paulo"
            loading="lazy"
            width="540"
            height="360"
          />
        </div>
        <div className="img-card">
          <img
            src="/img/hidrojateamento-litoral-sp.webp"
            alt="Desentope Maresias: hidrojateamento profissional em condomínio no litoral SP — atendimento 24h"
            loading="lazy"
            width="540"
            height="360"
          />
        </div>
      </div>
    </div>
  </section>
);
